export default __webpack_public_path__ + "static/media/remove-email.f6af64a6.svg";